import Curl from '$common/utils/curl/browser-curl';
import UrlModules from '$common/utils/curl/browser-curl/url-modules';
import { gateway_web as pix } from './api-pix';
const appgatewayHost = new UrlModules({ module: 'appgateway' });
const defaultCurl = (params, url, config) => new Curl().curl(params, `${appgatewayHost.host}/${pix}/${url}`, config);

/**
 * 标准埋点
 * @param {*} params
 */
export const warehouseCollectionSaveStandardCollectionData = (params, config) => defaultCurl(params, `warehouse/collection/saveStandardCollectionData.do`, config);

/**
 * 其他埋点
 * @param {*} params 
 * @param {*} config 
 * @returns 
 */
export const warehouseCollectionSaveOtherCollectionData = (params, config) => defaultCurl(params, `warehouse/collection/saveOtherCollectionData.do`, config);